import { createStyles, makeStyles, Theme } from '@material-ui/core';
import Colors from '../../components/Colors';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tableContainer: {
      margin: '30px 0 80px',
      padding: '5px 20px',
      background: '#F2F2F2',
    },
    table: {
      backgroundColor: 'white',
      boxShadow: theme.shadows[1],
      minHeight: '20vh',
    },
    tableHead: {
      backgroundColor: Colors.secundary,
      '& th': {
        color: '#404040',
      },
    },
    buttonsCol: {
      width: 300,
    },
    button: {
      borderRadius: 25,
      minWidth: 75,
      margin: '0 3px',
      textTransform: 'none',
    },
    loadingContainer: {
      display: 'flex',
      marginTop: '30px',
      justifyContent: 'center',
    },
    loadingSpinner: {
      color: Colors.secundary,
    },
    container: {
      display: 'flex',
      flexFlow: 'column',
      background: '#F2F2F2',
      border: ' 0.5px solid rgba(0, 0, 0, 0.2)',
      boxSizing: 'border-box',
      boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
      marginTop: '2%',
    },
    responsive: {
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
  }),
);
